import getDocRef from './getDocRef'
import { getDoc } from 'firebase/firestore/lite'

const getDataById = async (id, getCollection) => getDoc(getDocRef(id, getCollection())).then((d) => d.data())

export default getDataById
